import { VideoData } from '@anm/hosting-player';
import { useRef, FC } from 'react';
import { useSelector } from 'react-redux';
import useIsWebinar from '../../../../../../hooks/useIsWebinar';

import { EmbedItemProps } from '..';
import { hostedVideoSelectors } from '../../../../../../store/modules/hostedVideo';
import { landingsSelectors } from '../../../../../../store/modules/landings';
import PlayerBlock from '../../PlayerBlock';
import { CommonPreviewWrapper } from '../Wrapper';

const InlineEmbedPreview: FC<EmbedItemProps> = ({ hostId, errorCode, embedData, renderInnerContent }) => {
  const container = useRef<HTMLDivElement>(null);
  const videoData = useSelector(hostedVideoSelectors.selectVideoData);
  const isWebinar = useIsWebinar();
  const webinar = useSelector(landingsSelectors.selectLanding);

  if (!videoData) return null;

  const mappedData: VideoData = {
    ...videoData,
    customConfigs: {
      ...videoData.customConfigs,
      playerColor:
        isWebinar && webinar?.parameters?.playerColor
          ? webinar.parameters.playerColor
          : videoData.customConfigs.playerColor
    }
  };

  return (
    <CommonPreviewWrapper ref={container} width={container.current?.offsetWidth} sizeType={embedData.sizeType}>
      {renderInnerContent?.() || (
        <PlayerBlock
          {...{
            hostId,
            container,
            errorCode
          }}
          videoData={mappedData}
          sizes={videoData.sizes}
          fullWidth={true}
        />
      )}
    </CommonPreviewWrapper>
  );
};

export default InlineEmbedPreview;
